// Get the siblings of each element in the set of matched elements.
// This is the equivalent of .siblings() in jQuery. We abandon using jQuery in new marketing site scripts
export default function getSiblings ( element ) {
    const siblings = []
    let sibling = element.parentNode.firstChild

    while ( sibling ) {
        if ( sibling.nodeType === 1 && sibling !== element ) {
            siblings.push( sibling )
        }
        sibling = sibling.nextSibling
    }

    return siblings
}
